import $ from 'jquery';

import BaseVisualControlFactory from 'BaseVisualControlFactory.js';
import factoryService   from 'FactoryService.js';
import constants        from 'Constants.js';
import sequenceService  from 'SequenceService.js';

import ControlModel    from 'ControlModel.js';
import DateInputControlView  from 'common-inputs/DateInputControlView.js';
import dateUtil from 'shared/DateUtil.js';


//=============================================================================
//
// Alfonso Cabral, February 4, 2016
//
//=============================================================================
class ControlInputDateFactory extends BaseVisualControlFactory {

    constructor () {
        super();
    }

    createView( factoryKey, pos ) {

        const attributes = this.createChildAttributes( factoryKey, pos ) ;

        //adding silent(accessibility) to attributes.
        attributes.silent = false;
        attributes.styleColorText ='~inputTextColor';
        attributes.fontFamily = '~inputFont';
        attributes.fontSize = '~inputFont';
        attributes.textWeight = '~inputFont';
        attributes.textStyle  = '~inputFont';
        attributes.borderStyle= 'solid';
        attributes.borderSize= '1';
        attributes.cornerRadius= '2';
        attributes.borderColor = '~inputBorderColor';
        attributes.backgroundColor = '~inputBgColor';
        attributes.dateValue = '';
        attributes.showEmpty = 'true';
        attributes.showNow = 'false';
        attributes.specific = '';
        attributes.resizePadding = 2;
        attributes.specificDisplay = dateUtil.convertDateToISOString(new Date());
        attributes.specific = dateUtil.convertDateToISOString(new Date());
        attributes.format = 'MM/DD/YYYY';
        attributes.minYear = '1900';
        attributes.maxYear = '2100';
		attributes.minWidth = 70;
		attributes.lowestHeight = 15;
        this.resolveForInitialMinHeight(attributes);
        //Property exclusive for the heigth of the arrows' image this will never change similar functionality like the player
        attributes.imgHeight = 20;
        attributes.translateProps = [
            {key:"obligatoryMessage", label:"Mandatory Message"},
            {key:"toolTip", label:"Tooltip"},
            {key:"accessDesc", label:"Accessibility Description"},
        ];

        const view = new DateInputControlView( { model: new ControlModel( attributes ),  el: $(constants.FORM_ID),
            pos: pos, factoryKey: factoryKey, id: attributes.id } );

        return view;
    }

}

const controlInputDateFactory = new ControlInputDateFactory();

export default controlInputDateFactory;